import {Base} from "@/api/Base"

export class RemainingVacationEdit extends Base {
    path = "remainingVacation/edit"
}